import DashboardCard from 'components/DashboardCard';
import CenterContent from 'components/CenterContent';
import { Button } from 'antd';
import { useQuery } from 'hooks/apollo';
import useDataSource from 'hooks/useDataSource';
import React from 'react';
import { Link } from 'react-router-dom';
import { EDIT_LICENSE } from 'shared/constants/permissions';
import { Module } from 'shared/prisma/types';
import { hasAccessibilityLicense } from 'shared/utils/license';
import { renderDate } from 'components/Table/renderers';
import { GET_ACCESSIBILITY_DASHBOARD } from './graphql';
import { accessibilityCardLastScanAt, accessibilityCardStatistics } from './viewModel';

const AccessibilityCard = () => {
  const { dataSource, dataSourceId, loading, hasDataSourcePermission } = useDataSource();
  const hasAccessibility = hasAccessibilityLicense(dataSource?.activeLicense);
  const { data, loading: reviewLoading } = useQuery(GET_ACCESSIBILITY_DASHBOARD, {
    variables: { id: dataSourceId },
    skip: !dataSourceId || !hasAccessibility,
  });

  let cardContent = null;
  let cardProps = {};

  if (hasAccessibility) {
    const scope = data?.dataSource?.accessibilityReviewScopes?.[0];
    const scanOverview = scope?.scanOverview;
    const lastScanAt = accessibilityCardLastScanAt(scanOverview);
    cardProps = {
      resultsUrl: `/data-sources/${dataSourceId}/accessibility`,
      statistics: accessibilityCardStatistics(scanOverview),
      period: scope ? (
        lastScanAt
          ? (
            <>
              Last scan
              {renderDate(lastScanAt)}
            </>
          )
          : 'No scan yet'
      ) : undefined,
    };
    if (!reviewLoading && data && !scope) {
      cardContent = (
        <CenterContent>
          <p>Accessibility review is not active yet.</p>
        </CenterContent>
      );
    }
  } else {
    cardContent = (
      <CenterContent>
        <p>
          Your license does not include Accessibility.
        </p>
        {hasDataSourcePermission(EDIT_LICENSE) && (
          <Link to={`/data-sources/${dataSourceId}/settings/license`}>
            <Button type="primary">
              Upgrade license
            </Button>
          </Link>
        )}
      </CenterContent>
    );
  }

  return (
    <DashboardCard
      module={Module.Accessibility}
      title="Accessibility"
      name="accessibility"
      loading={loading || reviewLoading}
      disabled={!hasAccessibility}
      {...cardProps}
    >
      {cardContent}
    </DashboardCard>
  );
};

export default AccessibilityCard;
